import { QueryEntity } from '@datorama/akita';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {
  CostCenterItemsState,
  CostCenterItemsStore,
} from './cost-center-items.store';

@Injectable({
  providedIn: 'root',
})
export class CostCenterItemsQuery extends QueryEntity<CostCenterItemsState> {
  page$: Observable<number>;
  pageSize$: Observable<number>;
  lastPage$: Observable<boolean>;
  selectedCostCenter$: Observable<string>;

  constructor(protected store: CostCenterItemsStore) {
    super(store);
    this.lastPage$ = this.select((state) => state.lastPage);
    this.page$ = this.select((state) => state.page);
    this.pageSize$ = this.select((state) => state.pageSize);

    this.selectedCostCenter$ = this.selectActive().pipe(
      map((selectedCostCenter) =>
        selectedCostCenter?.number
          ? selectedCostCenter.number + ' - ' + selectedCostCenter.name
          : ''
      )
    );
  }
}
